import {
  ID,
  Guardian,
  Law,
  Documents,
  AcceptedPhotoId,
  MoneyBack,
  SharedDocument,
  User,
  DelayedFlight,
  Protect,
  Cancel,
  MoneyPaper,
  Luggage,
  CancelledFlight,
  TrustPilot,
  Ok,
  Heart,
  AirLuggage,
  AirPayout,
} from "@airhelp/icons";

const iconSizes = {
  s: 6,
  m: 8,
  l: 12,
  xl: 14,
} as Record<"s" | "m" | "l" | "xl", number>;

export const icons = {
  HammerIcon: Law,
  GuardianIcon: Guardian,
  ID,
  Documents,
  AcceptedPhotoId,
  MoneyBack,
  SharedDocument,
  User,
  DelayedFlight,
  Protect,
  Cancel,
  MoneyPaper,
  Luggage,
  CancelledFlight,
  TrustPilot,
  Ok,
  Heart,
  AirLuggage,
  AirPayout,
};

export type IconSizes = keyof typeof iconSizes;

export default iconSizes;
